import clsx from 'clsx';
import React from 'react';
import styles from './ReportBuilder.module.scss';

// ---- Underline tabs (matches Figma — SelectionBar uses pill style) ----

export interface TabOption<T extends string> {
    id: T;
    name: string;
}

interface ReportTabsProps<T extends string> {
    options: TabOption<T>[];
    selected: T;
    /* eslint-disable-next-line no-unused-vars */
    onSelect: (id: T) => void;
    className?: string;
}

function ReportTabsComponent<T extends string>({ options, selected, onSelect, className }: ReportTabsProps<T>) {
    return (
        <div className={clsx(styles.tabBar, className)}>
            {options.map(opt => (
                <button
                    key={opt.id}
                    type="button"
                    className={clsx(styles.tab, opt.id === selected && styles.tabActive)}
                    onClick={() => onSelect(opt.id)}
                >
                    {opt.name}
                </button>
            ))}
        </div>
    );
}

export const ReportTabs = React.memo(ReportTabsComponent) as typeof ReportTabsComponent;
